<template>
  <b-modal id="email-modal-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form>
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Email</label>
                <div class="col-md-8 mb-3">
                  {{detail.email}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Email Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.status == 1 ? 'Active' : 'Not Active'}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Modified</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_modified}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
export default {
  name: "EmailDetailForm",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{
        email:"",
        type_name:"",
        desc:"",
        status:"",
        last_modified:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.detail = this.data
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data =null
      this.detail = {
        email:"",
        type_name:"",
        desc:"",
        status:"",
        last_modified:""
      }
      this.$refs.modal.hide()
    }
  }
}
</script>